module.exports = __webpack_public_path__ + "static/charishma-9c9740ba42fb676095a367ba3ba219ce.jpg";